// extracted by mini-css-extract-plugin
export default {"skip_mobile":"Skip_skip_mobile__VypAu","skip_desktop":"Skip_skip_desktop__M6A6i"};